module.exports = __webpack_public_path__ + "static/media/apr2025_cdfr.86b45d0e.webp";